export var CommissionType;
(function (CommissionType) {
    CommissionType["Percentage"] = "percentage";
    CommissionType["Absolute"] = "absolute";
})(CommissionType || (CommissionType = {}));
